<cmps-wait-status
    [srStatus]="'Loading ' + config.title"
    *ngIf="hasPendingData"
></cmps-wait-status>
<div *ngIf="!hasPendingData && data == null">
    {{ i18n._711_NO_DATA_AVAILABLE | translate }}
</div>
<div
    class="container-fluid cmps-widget-dual-chart-performance-comparison"
    *ngIf="!hasPendingData && data != null"
>
    <div class="row">
        <!--TODO revise tl-->
        <div class="mb-2">
            <span class="sr-only">Date Range: </span
            >{{ dateRange[0] | date: 'y-MM-dd' }} -
            {{ dateRange[1] | date: 'y-MM-dd' }}
        </div>
    </div>
    <div class="row">
        <div
            class="col-12 col-sm-{{ 12 / data.length }} dcpc-pie-bar"
            *ngFor="let i of data"
        >
            <cmps-widget-pie-bar
                [data]="i"
                [hasPieBarClick]="true"
                (pieBarClick)="onPieBarClick($event)"
            ></cmps-widget-pie-bar>
        </div>
    </div>
</div>
